export const aboutData = {
  brandName: '北条麻妃电影全集精选',
  brandIntro: '北条麻妃电影全集精选是一个专注于北条麻妃电影作品的资源导航平台。我们致力于为全球华语影迷提供最全面、最权威的北条麻妃电影信息汇总服务。',
  mission: '让每一位影迷都能方便地找到自己想要欣赏的北条麻妃电影作品，是我们不变的使命。',
  story: `北条麻妃电影全集精选成立于2020年，由一群热爱日本影视艺术的影迷共同创建。在过去的几年中，我们从一个小型的作品列表逐步发展成为一个涵盖完整作品信息、分类导航、深度影评和观影指南的综合性平台。

我们深知，对于影迷来说，找到一个可靠、全面的电影信息平台有多么重要。因此，我们投入了大量的时间和精力来整理、校对和完善每一部作品的资料，力求为影迷提供最准确的信息。

如今，北条麻妃电影全集精选已经成为华语地区最具影响力的北条麻妃作品导航平台之一，每月为数万名影迷提供作品信息查询服务。`,
  reputation: [
    {
      name: '影迷张先生',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%20business%20casual%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20corporate%20portrait%20style%2C%20soft%20studio%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
      comment: '这个网站真的太棒了！北条麻妃的所有作品都整理得清清楚楚，分类也很合理，我每次想找一部作品的时候都会来这里。推荐给所有北条麻妃的影迷！',
      rating: 5,
      date: '2024-06-15'
    },
    {
      name: '影迷李女士',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20with%20warm%20smile%2C%20clean%20white%20background%2C%20friendly%20professional%20expression%2C%20corporate%20portrait%20style%2C%20soft%20studio%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish',
      comment: '作为一个新影迷，这个网站的观影指南对我帮助很大。按照推荐的顺序看下来，对北条麻妃的作品有了全面的了解。网站的界面也很清爽，用起来很舒服。',
      rating: 5,
      date: '2024-05-20'
    },
    {
      name: '资深影迷王先生',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20Asian%20man%20with%20glasses%2C%20clean%20white%20background%2C%20intellectual%20look%2C%20corporate%20portrait%20style%2C%20soft%20studio%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
      comment: '关注北条麻妃作品多年，这个网站是我见过资料最全、更新最快的。深度影评文章的质量也很高，每次读完都有新的收获。希望网站越做越好！',
      rating: 5,
      date: '2024-04-10'
    },
    {
      name: '影迷赵女士',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20confident%20smile%2C%20clean%20white%20background%2C%20modern%20professional%20look%2C%20corporate%20portrait%20style%2C%20soft%20studio%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish',
      comment: '分类功能非常实用！按精选、经典、最新、高分、独家五个维度分类，找片子特别方便。而且每部作品的介绍都写得很用心，看得出是真正懂北条麻妃的人在做这个网站。',
      rating: 5,
      date: '2024-03-25'
    }
  ],
  contact: {
    email: 'contact@hojomaki-film.com',
    wechat: 'hojomaki_film',
    qq: '1234567890',
    address: '中国上海市浦东新区',
    responseTime: '24小时内'
  }
};